module.exports = __webpack_public_path__ + "img/6c6fc9d.png";